import { useQuery } from "react-query";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

interface IdashboardRepaymenttGraph {
  aggregatorId: number;
  filter: number;
  currentCurrencyValue: string;
}
const getDashboardRepaymentsGraph = async ({
  aggregatorId,
  filter,
  currentCurrencyValue,
}: IdashboardRepaymenttGraph) => {
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.DASHBOARD_REPAYMENTS_GRAPH}?aggregatorId=${aggregatorId}&currency=${currentCurrencyValue}&filter=${filter}`,
  );
  return data;
};

export default function useDashboardRepaymentGraph({
  aggregatorId,
  filter,
  currentCurrencyValue,
}: IdashboardRepaymenttGraph) {
  return useQuery(
    [
      { aggregatorId, filter, currentCurrencyValue },
      "getDashboardRepaymentsGraph",
    ],
    getDashboardRepaymentsGraph,
    {
      enabled: currentCurrencyValue ? true : false,

      refetchOnWindowFocus: false,
      cacheTime: 1000,
    },
  );
}
